import
{
    CALIBRATIONV3SCREEN_LOAD,
    CALIBRATIONV3SCREEN_UNLOAD,
    CALIBRATIONV3SCREEN_SET,
} from '../../../actionDefinitions';
import { createReducer } from '../../../reducerUtils';

const initialState =
{
    //teamsCalibrationStats
    //currentTeamAgentsCalibrationStats

    //Agent Dashboard
    //agentJibeProgressOverTimeStats
    //agentCalibrationSummary
    //agentInteractions

    //teamsCalibrationStats:
    //[
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 76,
    //        "aggregationName": "All Teams",
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 324,
    //        "dateIndex": 1,
    //        "windowStart": "03/06/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": "All Teams",
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 324,
    //        "dateIndex": 1,
    //        "windowStart": "03/06/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 74,
    //        "aggregationName": "Baltimore",
    //        "aggregationId": 2,
    //        "surveyCnt": 0,
    //        "sessionCnt": 12,
    //        "dateIndex": 1,
    //        "windowStart": "03/06/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 63,
    //        "aggregationName": "Baltimore",
    //        "aggregationId": 2,
    //        "surveyCnt": 0,
    //        "sessionCnt": 12,
    //        "dateIndex": 1,
    //        "windowStart": "03/06/2024 00:00:00"
    //    }
    //]


    //currentTeamAgentsCalibrationStats:
    //[
    //    {
    //        "agentId": 7781532,
    //        "agentName": "agentName1",
    //        "surveyCnt": 1,
    //        "representativeSatisfactionCalibrationStatusId": 2,
    //        "resolutionCalibrationStatusId": 0,
    //        "customerSatisfactionCalibrationStatusId": 2,
    //        "netPromoterScoreCalibrationStatusId": 0,
    //        "representativeSatisfactionCalibrationScore": 100,
    //        "resolutionCalibrationScore": 0,
    //        "customerSatisfactionCalibrationScore": 100,
    //        "netPromoterScoreCalibrationScore": 0,
    //        "lastJibeSession": null,
    //        "jibeSessionsPast30DaysCount": 0
    //    },
    //    {
    //        "agentId": 7781397,
    //        "agentName": "agentName2",
    //        "surveyCnt": 37,
    //        "representativeSatisfactionCalibrationStatusId": 1,
    //        "resolutionCalibrationStatusId": 0,
    //        "customerSatisfactionCalibrationStatusId": 2,
    //        "netPromoterScoreCalibrationStatusId": 0,
    //        "representativeSatisfactionCalibrationScore": 75,
    //        "resolutionCalibrationScore": 0,
    //        "customerSatisfactionCalibrationScore": 71,
    //        "netPromoterScoreCalibrationScore": 0,
    //        "lastJibeSession": null,
    //        "jibeSessionsPast30DaysCount": 0
    //    },
    //]

    //agentCalibrationSummary
    //{
    //    "agentId": 7782906,
    //    "agentName": "agentName3",
    //    "surveyCnt": 0,
    //    "representativeSatisfactionCalibrationStatusId": 1,
    //    "resolutionCalibrationStatusId": 0,
    //    "customerSatisfactionCalibrationStatusId": 2,
    //    "netPromoterScoreCalibrationStatusId": 0,
    //    "representativeSatisfactionCalibrationScore": 76,
    //    "resolutionCalibrationScore": 0,
    //    "customerSatisfactionCalibrationScore": 63,
    //    "netPromoterScoreCalibrationScore": 0,
    //    "lastJibeSession": "2024-02-26T00:00:00-06:00",
    //    "jibeSessionsPast30DaysCount": 1
    //}

    //agentJibeProgressOverTimeStats:
    //[
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 80,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 0,
    //        "windowStart": "03/06/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 71,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 0,
    //        "windowStart": "03/06/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "ASAT",
    //        "overalSuccessRatePercent": 78,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 0,
    //        "windowStart": "03/07/2024 00:00:00"
    //    },
    //    {
    //        "questionCode": "CSAT",
    //        "overalSuccessRatePercent": 68,
    //        "aggregationName": null,
    //        "aggregationId": 0,
    //        "surveyCnt": 0,
    //        "sessionCnt": 0,
    //        "dateIndex": 0,
    //        "windowStart": "03/07/2024 00:00:00"
    //    }
    //]

    //agentInteractions
    //[
    //    {
    //        "id": 3947994,
    //        "interactionExternalId": null,
    //        "interactionExternalNumber": "27996178",
    //        "channelType": "Web",
    //        "reasonForContact": "social_club_account",
    //        "externalOpenDate": "03/23/2024 00:00:00",
    //        "agentName": "agentName1",
    //        "agentTeam": "Poland",
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": "AHS",
    //        "agentResponse": "Yes",
    //        "customerResponse": "5",
    //        "customerMappedResponse": "Yes",
    //        "responsesMatch": true
    //    },
    //    {
    //        "id": 3947994,
    //        "interactionExternalId": null,
    //        "interactionExternalNumber": "27996178",
    //        "channelType": "Web",
    //        "reasonForContact": "social_club_account",
    //        "externalOpenDate": "03/23/2024 00:00:00",
    //        "agentName": "agentName1",
    //        "agentTeam": "Poland",
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": "CES ",
    //        "agentResponse": "Yes",
    //        "customerResponse": "5",
    //        "customerMappedResponse": "Yes",
    //        "responsesMatch": true
    //    },
    //    {
    //        "id": 3926292,
    //        "interactionExternalId": null,
    //        "interactionExternalNumber": "28009080",
    //        "channelType": "Chat",
    //        "reasonForContact": "performance_issue",
    //        "externalOpenDate": "03/24/2024 00:00:00",
    //        "agentName": "agentName1",
    //        "agentTeam": "Poland",
    //        "questionCode": "ASAT",
    //        "clientSpecificShortName": "AHS",
    //        "agentResponse": "Yes",
    //        "customerResponse": "4",
    //        "customerMappedResponse": "Yes",
    //        "responsesMatch": true
    //    },
    //    {
    //        "id": 3926292,
    //        "interactionExternalId": null,
    //        "interactionExternalNumber": "28009080",
    //        "channelType": "Chat",
    //        "reasonForContact": "performance_issue",
    //        "externalOpenDate": "03/24/2024 00:00:00",
    //        "agentName": "agentName1",
    //        "agentTeam": "Poland",
    //        "questionCode": "CSAT",
    //        "clientSpecificShortName": "CES",
    //        "agentResponse": "Yes",
    //        "customerResponse": "5",
    //        "customerMappedResponse": "Yes",
    //        "responsesMatch": true
    //    },
    //]
};

const handlers = {
    [CALIBRATIONV3SCREEN_LOAD]: (state, action) =>
    {
        if (action.error)
        {
            return { error: action.payload };
        }
        return { ...action.payload, dataLoaded: true }
    },
    [CALIBRATIONV3SCREEN_UNLOAD]: () => initialState,
    [CALIBRATIONV3SCREEN_SET]: (state, action) => action.updatedProps,
};

export default createReducer(initialState, handlers);
